import { Box, Grid, Paper, Select, TextField, FormControl, CircularProgress, MenuItem, InputLabel, Checkbox , FormControlLabel} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useForm, Controller } from "react-hook-form";
import ButtonDatePicker from '../../components/DatePickers/ButtonDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ButtonTheme from "../../components/ThemeButton/ThemeButton";
import ApiService from "../../functions/apiService";
import AuthContext from "../../context/AuthContext";
import { useSnackbar } from "notistack";
import { setFunctionListDDL, setConTypeDDL, setCarrierDDL, setEMTDDL } from "../../store/ddlReducer";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { toast } from 'react-toastify';
// import { values } from "lodash";
import MyTable from "../../components/Schedule/MyTable";
import moment from "moment";
import Multiselect from 'multiselect-react-dropdown';
import { RotationForm } from "./EmployeeComponents/RotationForm";
import AssignmentHistoryModal from "./EmployeeComponents/AssignmentHistoryModal";
import Modal from 'react-bootstrap/Modal';
import { Row, Col } from "react-bootstrap";

export default function Employee() {
    const [user, setUser] = useState();
    const [groups, setGroups] = useState();
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [assignment, setAssignment] = useState();
    const [battalion, setBattalion] = useState(null);
    const [position, setPosition] = useState();
    const [ranks, setRanks] = useState();
    const [searchParams, setSearchParams] = useSearchParams();
    const [rowSelectionModel, setRowSelectionModel] = useState([]);
    const empId = searchParams.get("empId");
    const dispatch = useDispatch();
    const navigate = useNavigate();
    // const { enqueueSnackbar } = useSnackbar();
    const [rows, setRows] = useState();
		const [futureRotationRows, setFutureRotationRows] = useState();
		const [shift, setShift] = useState();
    const [isVehicle, setIsVehicle] = useState();
    const [vehicle, setVehicle] = useState(false);
    const { permission, pages, pagesName , v3Data } = useContext(AuthContext);
    const [certificateDropdown, setCertificateDropdown] = useState([])
    const [selectedCertificates, setSelectedCertificates] = useState([])
		const [deleteModal, setDeleteModal] = useState(false);
    const [statusDropdown, setStatusDropdown] = useState([])
    const [assignmentHistoryModal, setAssignmentHistoryModal] = useState(false);


    let groupName = Object.keys(pagesName).includes("GROUP_HEADER_TEXT") ? pagesName.GROUP_HEADER_TEXT : "Group";
    const {
        register,
        formState: { errors, isValid, isDirty },
        handleSubmit,
        setError,
        setValue,
        getValues,
        watch
    } = useForm({
        defaultValues: {
            Effective_Date: new Date().toISOString().split("T")[0],
            Certificate_Ids: [],
        }
    });


    let FunctionListDDL = useSelector((state) => { return state.ddlReducer.FunctionListDDL; });
    let ConTypeDDL = useSelector((state) => { return state.ddlReducer.ConTypeDDL; });
    let CarrierDDL = useSelector((state) => { return state.ddlReducer.CarrierDDL; });
    let EMTDDL = useSelector((state) => { return state.ddlReducer.EMTDDL; });
    let currentStatus = user?.employee_assignment?.EA_Status;
    let selectedStatus = watch("EA_Status", "A");
		let selectReturnDate = watch("Active_date");


    const columns = [
        { field: 'Effective_Date', headerName: 'Date', flex: 1, minWidth: 140 },
        { field: 'EA_Status', headerName: 'Status', flex: 1, minWidth: 120, },
        { field: 'EA_Rank', headerName: 'Rank', flex: 1, minWidth: 120, },
        { field: 'Group_Code', headerName: 'Group', flex: 1, minWidth: 120, },
        { field: 'Assignment_Code', headerName: 'Assignment', flex: 1, minWidth: 130, },
        { field: 'Position_Code', headerName: 'Position', flex: 1, minWidth: 130, },
        { field: 'EA_Division', headerName: 'Division', flex: 1, minWidth: 130, },
    ];

    useEffect(() => {
        if (FunctionListDDL.length == 0) {
            ApiService.get("/getFunctionListDDL", {}, 'getFunctionListDDL').then(({ data }) => {
                dispatch(setFunctionListDDL(data));
            });
        }
        if (ConTypeDDL.length == 0) {
            ApiService.get("/ConTypeDDL", {}, 'ConTypeDDL').then(({ data }) => {
                dispatch(setConTypeDDL(data));
            });
        }
        if (CarrierDDL.length == 0) {
            ApiService.get("/CarrierDDL", {}, 'CarrierDDL').then(({ data }) => {
                dispatch(setCarrierDDL(data));
            });
        }
        if (EMTDDL.length == 0) {
            ApiService.get("/EMTDDL", {}, 'EMTDDL').then(({ data }) => {
                dispatch(setEMTDDL(data));
            });
        }
        ApiService.get("/getGroups").then(({ data }) => {
            setValue('Group_Code', Object.keys(data.data)[0])
            setGroups(data.data);
        });
        ApiService.get("/getAssignment").then(({ data }) => {
            setAssignment(data.data);
        });
				ApiService.get("/getBattalions").then(({ data }) => {
            setBattalion(data?.data);
        });
        ApiService.get("/getPosition").then(({ data }) => {
            setPosition(data.data);
        });

        ApiService.get("/getVehicles").then(({ data }) => {
            setVehicle(data.data);
        });

        ApiService.get("/getRanks").then(({ data }) => {
            setRanks(data.data);
        });

				ApiService.get('/shiftTypes').then(({data}) => {
						setShift(data?.data)
				});

        if (empId) {
            ApiService.get("/getEmployee/" + empId).then(({ data }) => {
                let userData = data.data;
                setUser(userData);
                setLoading(false);
                setValue("First_Name", userData.First_name);
                setValue("Last_Name", userData.Last_name);
                setValue("Functional_Department", userData.Functional_Department);
                setValue("Unit_Number", userData.Unit_Number);
                setValue("Badge_Number", userData.Badge_Number);
                setValue("User_SMS_text", userData.User_SMS_text);
                setValue("EA_Status", userData.employee_assignment?.EA_Status);
                setValue("EA_Rank", userData.employee_assignment?.EA_Rank);
                setValue("Group_Code", userData.employee_assignment?.Group_Code);
                setValue("Assignment_Code", userData.employee_assignment?.Assignment_Code);
                setValue("Position_Code", userData.employee_assignment?.Position_Code);
                setValue("Primary_phone", userData.Primary_phone);
                setValue("Pphone_type", userData.Pphone_type);
                setValue("Pphone_provider", userData.Pphone_provider);
                setValue("Pager", userData.Pager);
                setValue("email", userData.email);
                setValue("EMS_Cert", userData.EMS_Cert);
				setValue('Do_Not_Call', userData?.Do_Not_Call)
                setValue('Preceptee', userData?.Preceptee)
                // console.log("user" , userData);

                // setValue("New_Seniority", userData.EHd_Seniority);
                // setValue("Old_Seniority", userData.EHd_Seniority);

                // setValue("Hire_date", new Date(userData.Hire_date));
                // setValue("Hire_date", userData.Hire_date);
                // setValue(
                //     "Effective_Date",
                //     userData.employee_assignment?.Effective_Date
                //     //   new Date(userData.employee_assignment?.Effective_Date)
                // );
                setLoading(false);
                setValue("New_Seniority", userData.EHd_Seniority);
                setValue("Old_Seniority", userData.EHd_Seniority);
                setValue("Hire_date", userData.Hire_date);
                setValue("Effective_Date", userData.employee_assignment?.Effective_Date);
                setValue("Effective_Date", new Date().toISOString().split("T")[0]);
                // setValue("Active_Date",userData?.employee_assignment?.Effective_Date);
                setValue("Auth_Auth", userData.permission.includes("Auth_Auth"));
                setValue("Pass_Auth", userData.permission.includes("Pass_Auth"));
                setValue("Emp_Auth", userData.permission.includes("Emp_Auth"));
                setValue("Schedule_Auth", userData.permission.includes("Schedule_Auth"));
                setValue("OT_Auth", userData.permission.includes("OT_Auth"));
                setValue("CB_Auth", userData.permission.includes("CB_Auth"));
                setValue("CBCls_Auth", userData.permission.includes("CBCls_Auth"));
                setValue("GR_Auth", userData.permission.includes("GR_Auth"));
                setValue("SMS_Auth", userData.permission.includes("SMS_Auth"));
                setValue("Notes_Auth", userData.permission.includes("Notes_Auth"));
								setValue("Inventory_Auth" , userData.permission.includes("Inventory_Auth"))
								setValue("Checklist_Auth" , userData.permission.includes("Checklist_Auth"))
                setRows(userData.employee_assignments);
								setFutureRotationRows(userData?.employee_future_rotations);
								setValue('Rotation', userData?.employee_rotation?.Rotation)
                setValue("Vehicle_Code", userData.employee_assignment?.Vehicle_Code);
                setValue("Certificate_Ids", userData?.employee_certificates?.map((i) => i.Certificate_id))
            });
        } else {
            setLoading(false);
        }
    }, []);

    const effectiveDateThreshold = new Date(user?.employee_assignment?.Effective_Date);
    const rowsData = rows
        ?.filter(row => new Date(row.Effective_Date) > effectiveDateThreshold)
        .map((row, index) => ({
            ...row,
            id: `${row.Emp_Code}-${row.Effective_Date}-${index}`,
        }));

		//rotation
		const rotationEffectiveDateThreshold = new Date(user?.employee_rotation?.Effective_Date);
		let rowsRotationData = futureRotationRows
		?.filter(row => new Date(row.Effective_Date) > rotationEffectiveDateThreshold)
		.map((row, index) => ({
				...row,
				id: `${row.Emp_Code}-${row.Effective_Date}-${index}`,
				days: Array.from(row.Rotation.split(',').map((item) => ({ value: item }))),
		}));

		let rotationColumns = [
			{ field: 'Effective_Date', headerName: 'Start Date', flex: 1, maxWidth: 140 },

		];

		if(typeof rowsRotationData !== 'undefined') {
			
			let i = 0;
			rowsRotationData.forEach((v1, key) => {
				v1.days.forEach((v2, key2) => {
					//determine how many columns to populate
					if(i < key2+1) {
						i++;
					}
					//setting up display strings
					let displayString ='';
					if(v2.value == 'X') {
						displayString = 'Not Working';
					}
					else {
						let arrShifts = String(v2.value).split('');
						arrShifts.forEach((as, key3) => {
							shift.forEach((shifts, key4) => {
								if(shifts.ShiftCode == as) {
									if(key3 > 0) {
										displayString = displayString + ' & ' + shifts.Shift;
									}
									else {
										displayString = shifts.Shift;
									}
								}
							});
						})
					}
					//set fields for displaying
					rowsRotationData[key][`day${key2}`] = displayString;
				});
			});
			//create columns
			for(let q = 0; q < i; q++){
				rotationColumns.push({ field: `day${q}`, headerName: `Day ${q + 1}`, flex: 1, maxWidth: 200, })
			}
		}

		//console.log(rotationColumns);
    const back = () => {
        navigate(-1);
    };

    const onSubmit = async (d) => {
			if (d.Preceptee === true) {
				d.Preceptee = 1
			}
			else if (d.Preceptee === false) {
				d.Preceptee = 0
			}
			if(d.Do_Not_Call === true){
				d.Do_Not_Call='1'
			}
			else if(d.Do_Not_Call === false) {
				d.Do_Not_Call = '0'
			}
        setSaving(true);
        try {
            if (empId) {
                await ApiService.post("/editEmployee/" + empId, d)
                    .then((res) => {
                        toast.success(res?.message)
                        setSaving(false);
                        navigate("/firehouse/members");
                    })
                    .catch(({ data }) => {
                        setSaving(false);
                        toast.error(data.message)
                        if (data.errors) {
                            Object.entries(data.errors).forEach((value) => {
                                setError(value[0], { message: value[1] });
                            });
                        }
                    });
            } else {
                await ApiService.post("/addEmployee", d)
                    .then((res) => {
                        toast.success(res?.message)
                        setSaving(false);
                        navigate("/firehouse/members");
                    })
                    .catch(({ data }) => {
                        setSaving(false);
                        toast.error(data.message)
                        if (data.errors) {
                            Object.entries(data.errors).forEach((value) => {
                                setError(value[0], { message: value[1] });
                            });
                        }

                    });
            }
        } catch (error) {
            setSaving(false);
            toast.error("Error")
            // enqueueSnackbar("Error", { variant: "error" });
        }
    };

    const onRowSelectionModelChange = (newSelection) => {
        setRowSelectionModel(newSelection);
    };

    const refreshEmployeeAssignments = () => {
        if (!empId) return;
        ApiService.get("/getEmployee/" + empId).then(({ data }) => {
            setUser(data.data);
            setRows(data.data.employee_assignments);
        });
    };

    let handleDelete = async () => {
        setLoading(true);

        const selectedRows = rowSelectionModel.map(id =>
            rowsData.find(row => row.id === id)
        );

        try {
            const updatedRows = [...rows];

            for (const row of selectedRows) {
                await ApiService.delete('/deleteEmployeeAssignment', {
                    Emp_Code: row.Emp_Code,
                    Effective_Date: row.Effective_Date,
                    Group_Code: row.Group_Code,
                    Assignment_Code: row.Assignment_Code,
                    Position_Code: row.Position_Code,
                    EA_Status: row.EA_Status,
                    EA_Rank: row.EA_Rank,
                    EA_Division: row.EA_Division,
                });

                const indexToRemove = updatedRows.findIndex(
                    r =>
                        r.Emp_Code === row.Emp_Code &&
                        r.Effective_Date === row.Effective_Date
                );
                if (indexToRemove !== -1) {
                    updatedRows.splice(indexToRemove, 1);
                }
            }
            setRows(updatedRows);
        } catch (error) {
            console.error("Error deleting rows:", error);
        } finally {
            setLoading(false);
        }
    };

		let handleDeleteRotation = async () => {
        setLoading(true);

        const selectedRows = rowSelectionModel.map(id =>
            rowsRotationData.find(row => row.id === id)
        );

        try {
            const updatedRows = [...rowsRotationData];

            for (const row of selectedRows) {
                await ApiService.delete('/deleteEmployeeRotation', {
                    Emp_Code: row.Emp_Code,
                    Effective_Date: row.Effective_Date,
                });

                const indexToRemove = updatedRows.findIndex(
                    r =>
                        r.Emp_Code === row.Emp_Code &&
                        r.Effective_Date === row.Effective_Date
                );
                if (indexToRemove !== -1) {
                    updatedRows.splice(indexToRemove, 1);
                }
            }
            setFutureRotationRows(updatedRows);
        } catch (error) {
            console.error("Error deleting rows:", error);
        } finally {
            setLoading(false);
        }
    };
    const certificateDropdownData = () => {
        setLoading(true);
        ApiService.get('/get-certificates-dropdown')
            .then(({ data }) => {
                var certArr = data?.data.map((cer) => { return { label: cer.Name, value: cer.Certificate_id } })
                setCertificateDropdown(certArr || [])
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
            })
    }

    const statusDropdownData = () => {
        setLoading(true);
        ApiService.get('/getStatusListDDL')
            .then(({ data }) => {
                var certArr = data.map((status) => { return { label: status.SO_Desc, value: status.SO_Value } })
                setStatusDropdown(certArr || [])
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
            })
    }

    useEffect(() => {
        certificateDropdownData()
        statusDropdownData()
    }, [])

    if (loading) {
        return (
            <Box className="w-100 h-100 d-flex justify-content-center align-items-center">
                <CircularProgress />
            </Box>
        );
    } else {
        return (
					<>
            <Box className="m-3">
                <Box>
                    <Link to="/firehouse/members" style={{ color: "#555555" }}>
                        <ArrowBackIosIcon />
                    </Link>
                    <span className="fw-500  fs-5">
                        {empId ? "Edit" : "Add"} Employee
                    </span>
                </Box>
                <form onSubmit= {handleSubmit(onSubmit)}>

                    {/* <FormControl> */}

                        <Paper className="p-4 my-3">
                            <p className="fw-500 fs-5">Name</p>
                            <Grid
                                container
                                spacing={2}
                                columns={{ xs: 4, sm: 1, md: 4 }}
                            >
                                {!user &&
                                    <Grid item xs={2} sm={1}>
                                        <TextField
                                            {...register("First_Name", {
                                                required: "First Name is required",                
                                            })}
                                            required={true}
                                            className="mt-0 w-100"
                                            color="secondary"
                                            variant="outlined"
                                            label="First Name"
                                        />
                                        {errors.First_Name && (
                                            <p style={{ color: "red" }}>
                                                {errors.First_Name?.message}
                                            </p>
                                        )}
                                    </Grid>
                                }

                            {user &&
                                <Grid item xs={2} sm={1}>
                                    <TextField
                                        {...register("First_Name", {
                                            required: "First Name is required",
                                        })}
                                        defaultValue={user?.First_name}
                                        required={true}
                                        className="mt-0 w-100"
                                        color="secondary"
                                        variant="outlined"
                                        label="First Name"
                                    />
                                    {errors.First_Name && (
                                        <p style={{ color: "red" }}>
                                            {errors.First_Name?.message}
                                        </p>
                                    )}
                                </Grid>
                            }

                            {!user &&
                                <Grid item xs={2} sm={1}>
                                    <TextField
                                        {...register("Last_Name", {
                                            required: "Last Name is required",
                                        })}
                                        required={true}
                                        className="mt-0 w-100"
                                        color="secondary"
                                        variant="outlined"
                                        label="Last Name"
                                    />
                                    {errors.Last_Name && (
                                        <p style={{ color: "red" }}>
                                            {errors.Last_Name?.message}
                                        </p>
                                    )}
                                </Grid>
                            }

                            {user &&
                                <Grid item xs={2} sm={1}>
                                    <TextField
                                        {...register("Last_Name", {
                                            required: "Last Name is required",
                                        })}
                                        required={true}
                                        defaultValue={user?.Last_name}
                                        className="mt-0 w-100"
                                        color="secondary"
                                        variant="outlined"
                                        label="Last Name"
                                    />
                                    {errors.Last_Name && (
                                        <p style={{ color: "red" }}>
                                            {errors.Last_Name?.message}
                                        </p>
                                    )}
                                </Grid>
                            }


                            <Grid item xs={2} sm={1}>
                                {user && (
                                    <TextField
                                        {...register("Functional_Department")}
                                        className="mt-0 w-100"
                                        color="secondary"
                                        variant="outlined"
                                        select
                                        SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                        label="Function"
                                        // defaultValue={'FIRE'}
                                        defaultValue={
                                            user.Functional_Department
                                        }
                                    // helperText="Please select your currency"
                                    >
                                        {FunctionListDDL.map(i => <MenuItem value={i.SO_Value} key={i.SO_Value}>{i.SO_Desc} </MenuItem>)}
                                    </TextField>
                                )}
                                {!user && (
                                    <TextField
                                        {...register("Functional_Department")}
                                        className="mt-0 w-100"
                                        color="secondary"
                                        variant="outlined"
                                        select
                                        SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                        label="Type"
                                        defaultValue={"FIRE"}
                                    // helperText="Please select your currency"
                                    >
                                        {FunctionListDDL.map(i => <MenuItem value={i.SO_Value} key={i.SO_Value}>{i.SO_Desc} </MenuItem>)}
                                    </TextField>
                                )}

                                {errors.Functional_Department && (
                                    <p style={{ color: "red" }}>
                                        {
                                            errors.Functional_Department
                                                ?.message
                                        }
                                    </p>
                                )}
                            </Grid>

                            {user &&
                                <Grid item xs={3} sm={1}>
                                    {pages.includes('V3_SENIORITY_FORCE_UPDATE') ?
                                        <>
                                            <TextField
                                                {...register("New_Seniority")}
                                                className="mt-0 w-100"
                                                color="secondary"
                                                type="number"
                                                variant="outlined"
                                                label="Seniority"
                                                inputProps={{ step: "0.1" }}
                                            />
                                            <TextField
                                                {...register("Old_Seniority")}
                                                type="number"
                                                inputProps={{ step: "0.1" }}
                                                hidden
                                            />
                                        </> :
                                        <>
                                            <TextField
                                                {...register("New_Seniority")}
                                                className="mt-0 w-100"
                                                color="secondary"
                                                type="number"
                                                variant="outlined"
                                                label="Seniority"
                                            />
                                            <TextField
                                                {...register("Old_Seniority")}
                                                type="number"
                                                hidden
                                            />
                                        </>
                                    }

                                    {errors.EHd_Seniority && (
                                        <p style={{ color: "red" }}>
                                            {errors.EHd_Seniority?.message}
                                        </p>
                                    )}
                                </Grid>
                            }

                            {!user &&
                                <Grid item xs={2} sm={1}>
                                    <TextField
                                        {...register("Unit_Number")}
                                        className="mt-0 w-100"
                                        color="secondary"
                                        variant="outlined"
                                        label="Unit"
                                    />
                                    {errors.Unit_Number && (
                                        <p style={{ color: "red" }}>
                                            {errors.Unit_Number?.message}
                                        </p>
                                    )}
                                </Grid>
                            }

                            {user &&
                                <Grid item xs={2} sm={1}>
                                    <TextField
                                        {...register("Unit_Number")}
                                        className="mt-0 w-100"
                                        color="secondary"
                                        variant="outlined"
                                        label="Unit"
                                        defaultValue={user?.Unit_Number}
                                    />
                                    {errors.Unit_Number && (
                                        <p style={{ color: "red" }}>
                                            {errors.Unit_Number?.message}
                                        </p>
                                    )}
                                </Grid>
                            }

                            {!user &&
                                <Grid item xs={2} sm={1}>
                                    <TextField
                                        {...register("Badge_Number")}
                                        className="mt-0 w-100"
                                        color="secondary"
                                        variant="outlined"
                                        label="Badge"
                                    />
                                    {errors.Badge_Number && (
                                        <p style={{ color: "red" }}>
                                            {errors.Badge_Number?.message}
                                        </p>
                                    )}
                                </Grid>
                            }

                            {user &&
                                <Grid item xs={2} sm={1}>
                                    <TextField
                                        {...register("Badge_Number")}
                                        className="mt-0 w-100"
                                        color="secondary"
                                        variant="outlined"
                                        label="Badge"
                                        defaultValue={user?.Badge_Number}
                                    />
                                    {errors.Badge_Number && (
                                        <p style={{ color: "red" }}>
                                            {errors.Badge_Number?.message}
                                        </p>
                                    )}
                                </Grid>
                            }

                        </Grid>
                    </Paper>

                        <Paper className="p-4 my-3">
                            <div className="d-flex align-items-center justify-content-between flex-wrap">
                                <p className="fw-500 fs-5" style={{marginBottom: '0px'}}>Rank & Assignment</p>
                                {empId && (
                                    <ButtonTheme
                                        type="button"
                                        variant="filled"
                                        color="DarkRed"
                                        onClick={() => setAssignmentHistoryModal(true)}
                                    >
                                        View All Assignments
                                        {rows?.length > 0 ? ` (${rows.length})` : ""}
                                    </ButtonTheme>
                                )}
                            </div>
																									<div style={{ display: 'flex', gap: '40px', alignItems: 'center', flexWrap: 'wrap' }}>
<Box className='my-2'>
																	<div
																		className='form-check form-switch d-flex align-items-center'
																		style={{ height: '50px' }}
																	>
																		<input
																			style={{ width: '40px', height: '25px', marginBottom: '18px' }}
																			{...register('Do_Not_Call')}
																			// onChange={(e) => {setValue('Do_Not_Call', e.target.checked ? '1' : '0')}}	
																			checked={watch('Do_Not_Call') == true || watch('Do_Not_Call') === '1'}
																			id='flexSwitch'
																			className='form-check-input'
																			type='checkbox'
																			role='switch'
																		/>
																		<label className='form-check-label mx-2' htmlFor='flexSwitch' style={{ marginBottom: '18px' }} >
																			Do Not Disturb
																		</label>
																	</div>
															</Box>
                                                        {v3Data?.V3_PRECEPTEE_EMP && v3Data?.V3_PRECEPTEE_EMP == 'true' &&
                                                        <Box className='my-2'>
															<div
																className='form-check form-switch d-flex align-items-center'
																style={{ height: '50px' }}
															>
																<input
																	style={{ width: '40px', height: '25px', marginBottom: '18px' }}
																	{...register('Preceptee')}
																	checked={watch('Preceptee') == true || watch('Preceptee') === 1 || watch('Preceptee') === '1'}
																	id='flexSwitchPreceptee'
																	className='form-check-input'
																	type='checkbox'
																	role='switch'
																/>
																<label className='form-check-label mx-2' htmlFor='flexSwitchPreceptee' style={{ marginBottom: '18px' }} >
																	Preceptee
																</label>
															</div>
														</Box>}
											</div>
                            <Grid
                                container
                                spacing={2}
                                columns={{ xs: 4, sm: 1, md: 4 }}
                            >
                            <Grid item xs={2} sm={1}>
                            {user && (
                                <TextField
                                select
                                SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                label="Status"
                                defaultValue={user.employee_assignment?.EA_Status}
                                {...register("EA_Status", {
                                    required: "Status is required",
                                    onChange: (e) => {
                                    if (e.target.value === "D") setDeleteModal(true);
                                    },
                                })}
                                required
                                className="mt-0 w-100"
                                color="secondary"
                                variant="outlined"
                                >
                                {statusDropdown.map((item) => (
                                    <MenuItem key={item.value} value={item.value}>
                                    {item.label}
                                    </MenuItem>
                                ))}
                                </TextField>
                            )}

                            {!user && (
                                <TextField
                                select
                                SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                label="Status"
                                {...register("EA_Status", {
                                    required: "Status is required",
                                    onChange: (e) => {
                                    if (e.target.value === "D") setDeleteModal(true);
                                    },
                                })}
                                required
                                className="mt-0 w-100"
                                color="secondary"
                                variant="outlined"
                                defaultValue="A"
                                >
                                {statusDropdown.map((item) => (
                                    <MenuItem key={item.value} value={item.value}>
                                    {item.label}
                                    </MenuItem>
                                ))}
                                </TextField>
                            )}

                            {errors?.EA_Status && (
                                <p style={{ color: "red" }}>
                                {errors.EA_Status.message}
                                </p>
                            )}
                            </Grid>
                                <Grid item xs={2} sm={1}>
                                    {user && (
                                        <TextField
                                            select
                                            SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                            label="Rank"
                                            {...register("EA_Rank", {
                                                required: "Rank is required",
                                            })}
                                            required={true}
                                            className="mt-0 w-100"
                                            color="secondary"
                                            variant="outlined"
                                            defaultValue={
                                                user?.employee_assignment
                                                    ?.EA_Rank
                                            }
                                        >
                                            {ranks &&
                                                Object.values(ranks).map(
                                                    (item) => (
                                                        <MenuItem
                                                            key={item.SO_Value}
                                                            value={
                                                                item.SO_Value
                                                            }
                                                        >
                                                            {item.SO_Desc}{" "}
                                                        </MenuItem>
                                                    )
                                                )}
                                        </TextField>
                                    )}
                                    {!user && (
                                        <TextField
                                            select
                                            SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                            label="Rank"
                                            {...register("EA_Rank", {
                                                required: "Rank is required",
                                            })}
                                            required={true}
                                            className="mt-0 w-100"
                                            color="secondary"
                                            variant="outlined"
                                            defaultValue="FF"
                                        >
                                            {ranks &&
                                                Object.values(ranks).map(
                                                    (item) => (
                                                        <MenuItem
                                                            key={item.SO_Value}
                                                            value={
                                                                item.SO_Value
                                                            }
                                                        >
                                                            {item.SO_Desc}{" "}
                                                        </MenuItem>
                                                    )
                                                )}
                                        </TextField>
                                    )}
                                    {errors.EA_Rank && (
                                        <p style={{ color: "red" }}>
                                            {errors.EA_Rank?.message}
                                        </p>
                                    )}
                                </Grid>

                            <Grid item xs={2} sm={1}>
                                {user && (
                                    <TextField
                                        {...register("Group_Code", {
                                            required: "Group is required",
                                        })}
                                        required={true}
                                        className="mt-0 w-100"
                                        color="secondary"
                                        variant="outlined"
                                        select
                                        SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                        label={groupName}
                                        defaultValue={
                                            user &&
                                            user?.employee_assignment
                                                ?.Group_Code
                                        }
                                    >
                                        {groups &&
                                            Object.keys(groups).map((item) => (
                                                <MenuItem
                                                    value={item}
                                                    key={item}
                                                >
                                                    {groups[item]}
                                                </MenuItem>
                                            ))}
                                    </TextField>
                                )}
                                {!user && (
                                    <TextField
                                        {...register("Group_Code", {
                                            required: "Group is required",
                                        })}
                                        required={true}
                                        className="mt-0 w-100"
                                        color="secondary"
                                        variant="outlined"
                                        select
                                        SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                        label={groupName}
                                        defaultValue="1"
                                    >
                                        {groups &&
                                            Object.keys(groups).map((item) => (
                                                <MenuItem
                                                    value={item}
                                                    key={item}
                                                >
                                                    {groups[item]}
                                                </MenuItem>
                                            )
                                            )}
                                    </TextField>
                                )}
                                {errors.Group && (
                                    <p style={{ color: "red" }}>
                                        {errors.Group?.message}
                                    </p>
                                )}
                            </Grid>

                            {pages.includes('V3_VEHICLE_ASSIGNMENT') ? (
                                <Grid item xs={2} sm={1}>
                                    {user && pages.includes('V3_VEHICLE_ASSIGNMENT') && (
                                        <TextField
                                            select
                                            SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                            label="Vehicle Code"
                                            defaultValue={
                                                user?.employee_assignment?.Vehicle_Code
                                            }
                                            {...register("Vehicle_Code")}
                                            className="mt-0 w-100"
                                            color="secondary"
                                            variant="outlined"
                                        >
                                            <MenuItem value="empty">No Vehicle Selection</MenuItem>
                                            {vehicle &&
                                                Object.values(vehicle).map(
                                                    (item) => (
                                                        <MenuItem
                                                            key={item.SO_Value}
                                                            value={
                                                                item.SO_Value
                                                            }
                                                        >
                                                            {item.SO_Desc}{" "}
                                                        </MenuItem>
                                                    )
                                                )}
                                        </TextField>
                                    )}
                                    {!user && pages.includes('V3_VEHICLE_ASSIGNMENT') && (
                                        <TextField
                                            select
                                            SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                            label="Vehicle Code"
                                            {...register("Vehicle_Code")}
                                            className="mt-0 w-100"
                                            color="secondary"
                                            variant="outlined"
                                        >
                                            <MenuItem value="empty">No Vehicle Selection</MenuItem>
                                            {vehicle &&
                                                Object.values(vehicle).map(
                                                    (item) => (
                                                        <MenuItem
                                                            key={item.SO_Value}
                                                            value={
                                                                item.SO_Value
                                                            }
                                                        >
                                                            {item.SO_Desc}{" "}
                                                        </MenuItem>
                                                    )
                                                )}
                                        </TextField>
                                    )}
                                    {errors.Vehicle_Code && (
                                        <p style={{ color: "red" }}>
                                            {errors.Vehicle_Code?.message}
                                        </p>
                                    )}
                                </Grid>
                            ) : ''}

                            <Grid item xs={2} sm={1}>
                                {user && (
                                    <TextField
                                        select
                                        SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                        label="Position"
                                        defaultValue={
                                            user?.employee_assignment
                                                ?.Position_Code
                                        }
                                        {...register("Position_Code", {
                                            required:
                                                "Position is required",
                                        })}
                                        required={true}
                                        className="mt-0 w-100"
                                        color="secondary"
                                        variant="outlined"
                                    >
                                        {position &&
                                            Object.values(position).map(
                                                (item) => (
                                                    <MenuItem
                                                        key={item.SO_Value}
                                                        value={
                                                            item.SO_Value
                                                        }
                                                    >
                                                        {item.SO_Desc}{" "}
                                                    </MenuItem>
                                                )
                                            )}
                                    </TextField>
                                )}
                                {!user && (
                                    <TextField
                                        select
                                        SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                        label="Position"
                                        {...register("Position_Code", {
                                            required:
                                                "Position is required",
                                        })}
                                        required={true}
                                        className="mt-0 w-100"
                                        color="secondary"
                                        variant="outlined"
                                    >
                                        {position &&
                                            Object.values(position).map(
                                                (item) => (
                                                    <MenuItem
                                                        key={item.SO_Value}
                                                        value={
                                                            item.SO_Value
                                                        }
                                                    >
                                                        {item.SO_Desc}{" "}
                                                    </MenuItem>
                                                )
                                            )}
                                    </TextField>
                                )}
                                {errors.Position_Code && (
                                    <p style={{ color: "red" }}>
                                        {errors.Position_Code?.message}
                                    </p>
                                )}



                                
                            </Grid>

                            	{user && battalion?.length > 0 ? (
                                    <Grid item xs={2} sm={1}>
                                            <TextField
                                                select
                                                SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                                label="Battalion"
                                                defaultValue={
                                                    user?.employee_assignment?.Battalion_Code
                                                }
                                                {...register("Battalion_Code")}
                                                className="mt-0 w-100"
                                                color="secondary"
                                                variant="outlined"
                                            >
                                                <MenuItem value="empty">No Selection</MenuItem>
                                                {battalion &&
                                                    battalion.map(
                                                        (item) => (
                                                            <MenuItem
                                                                key={item.SO_Value}
                                                                value={item.SO_Value}
                                                            >
                                                                {item.SO_Desc}{" "}
                                                            </MenuItem>
                                                        )
                                                    )}
                                            </TextField>

                                        {errors.Battalion_Code && (
                                            <p style={{ color: "red" }}>
                                                {errors.Battalion_Code?.message}
                                            </p>
                                        )}
                                    </Grid>
                                ) : ''}

																{!user && battalion?.length > 0 ? (
                                    <Grid item xs={2} sm={1}>
                                            <TextField
                                                select
                                                SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                                label="Battalion"
                                                defaultValue={
                                                    user?.employee_assignment?.Battalion_Code
                                                }
                                                {...register("Battalion_Code")}
                                                className="mt-0 w-100"
                                                color="secondary"
                                                variant="outlined"
                                            >
                                                <MenuItem value="empty">No Selection</MenuItem>
                                                {battalion &&
                                                    battalion.map(
                                                        (item) => (
                                                            <MenuItem
                                                                key={item.SO_Value}
                                                                value={item.SO_Value}
                                                            >
                                                                {item.SO_Desc}{" "}
                                                            </MenuItem>
                                                        )
                                                    )}
                                            </TextField>

                                        {errors.Battalion_Code && (
                                            <p style={{ color: "red" }}>
                                                {errors.Battalion_Code?.message}
                                            </p>
                                        )}
                                    </Grid>
                                ) : ''}

                            <Grid item xs={2} sm={1}>
                                {user && (
                                    <TextField
                                        select
                                        SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                        label="Assignment"
                                        defaultValue={
                                            user?.employee_assignment
                                                ?.Assignment_Code
                                        }
                                        {...register("Assignment_Code", {
                                            required:
                                                "Assignment is required",
                                        })}
                                        required={true}
                                        className="mt-0 w-100"
                                        color="secondary"
                                        variant="outlined"
                                    >
                                        {assignment &&
                                            Object.values(assignment).map(
                                                (item) => (
                                                    <MenuItem
                                                        key={item.SO_Value}
                                                        value={
                                                            item.SO_Value
                                                        }
                                                    >
                                                        {item.SO_Desc}{" "}
                                                    </MenuItem>
                                                )
                                            )}
                                    </TextField>
                                )}
                                {!user && (
                                    <TextField
                                        label="Assignment"
                                        select
                                        SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                        {...register("Assignment_Code", {
                                            required:
                                                "Assignment is required",
                                        })}
                                        required={true}
                                        className="mt-0 w-100"
                                        color="secondary"
                                        variant="outlined"
                                    >
                                        {assignment &&
                                            Object.values(assignment).map(
                                                (item) => (
                                                    <MenuItem
                                                        key={item.SO_Value}
                                                        value={
                                                            item.SO_Value
                                                        }
                                                    >
                                                        {item.SO_Desc}{" "}
                                                    </MenuItem>
                                                )
                                            )}
                                    </TextField>
                                )}

                                {errors.Assignment_Code && (
                                    <p style={{ color: "red" }}>
                                        {errors.Assignment_Code?.message}
                                    </p>
                                )}
                            </Grid>


                            {user && (
                                <Grid item xs={2} sm={1}>
                                    <div>
                                        <LocalizationProvider
                                            dateAdapter={AdapterDateFns}
                                        >
                                            <>
                                                <TextField
                                                    className="mt-0 w-100"
                                                    color="secondary"
                                                    type="date"
                                                    variant="outlined"
                                                    label="Effective Date"
                                                    {...register("Effective_Date")}
                                                />
                                            </>
                                        </LocalizationProvider >
                                    </div >
                                    {
                                        errors.Effective_Date && (
                                            <p style={{ color: "red" }}>
                                                {errors.Effective_Date?.message}
                                            </p>
                                        )
                                    }
                                </Grid >
                            )
                            }
														{
																user && (selectedStatus !== "A" && selectedStatus !== "D" && selectedStatus !== "R") && (
																		<Grid item xs={2} sm={1}>
																			<div>
																				<LocalizationProvider dateAdapter={AdapterDateFns}>
																						<DatePicker
																								label="Return to Active Date"
																								sx={{
																									width: "100%",
																									"& .MuiInputBase-root": {
																										height: 56, 
																									},
																									"& .MuiInputBase-input": {
																										padding: "12px 14px",
																									},
																								}}
																								{...register("Active_date", { required: "Active_date is required" })}
																								format="MM/dd/yyyy"
																								onChange={(e) => setValue("Active_date", moment(e).format("YYYY-MM-DD"))}
																						/>
																				</LocalizationProvider>
																			</div>
																			{errors.Effective_Date && (
																					<p style={{ color: "red" }}>
																							{errors.Effective_Date?.message}
																					</p>
																			)}
																		</Grid>
																)
														}
                            </Grid >
                        </Paper >

												{empId && rowsRotationData?.length >= 1 ? (
                            <Paper className="p-4 my-3">
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <p className="fw-500 fs-5">Future Shift Schedule</p>
                                    <ButtonTheme
                                        disabled={rowSelectionModel.length === 0}
                                        type="submit"
                                        variant="filled"
                                        color="DarkRed"
                                        className="px-5"
                                        onClick={handleDeleteRotation}
                                    >
                                        Delete
                                    </ButtonTheme>
                                </div>
                                <Box className="my-2">
                                    <MyTable
                                        rows={rowsRotationData}
                                        columns={rotationColumns}
                                        checkboxSelection
                                        hideFooter={true}
                                        selectedRows={rowSelectionModel}
                                        onRowSelectionModelChange={onRowSelectionModelChange}
                                        disableRowSelectionOnClick={false}
                                        perPage={10}
                                        rowCount={rows.length}
                                    />
                                </Box>
                            </Paper>
                        ) : ('')
                        }

                        {empId && rowsData?.length >= 1 ? (
                            <Paper className="p-4 my-3">
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <p className="fw-500 fs-5">Future Reassignments</p>
                                    <ButtonTheme
                                        disabled={rowSelectionModel.length === 0}
                                        type="submit"
                                        variant="filled"
                                        color="DarkRed"
                                        className="px-5"
                                        onClick={handleDelete}
                                    >
                                        Delete
                                    </ButtonTheme>
                                </div>
                                <Box className="my-2">
                                    <MyTable
                                        rows={rowsData}
                                        columns={columns}
                                        checkboxSelection
                                        hideFooter={true}
                                        selectedRows={rowSelectionModel}
                                        onRowSelectionModelChange={onRowSelectionModelChange}
                                        disableRowSelectionOnClick={false}
                                        perPage={10}
                                        rowCount={rows.length}
                                    />
                                </Box>
                            </Paper>
                        ) : ('')
                        }

                        <RotationForm register={register} errors={errors} setValue={setValue} watch={watch} user={user}/>

                        <Paper className="p-4 my-3">
                            <p className="fw-500 fs-5">EMS Information</p>
                            <Grid
                                container
                                spacing={2}
                                columns={{ xs: 4, sm: 1, md: 4 }}
                            >
                                <Grid item xs={2} sm={1}>
                                    {user && (
                                        <TextField
                                            select
                                            SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                            label="EMT"
                                            defaultValue={user?.EMS_Cert}
                                            {...register("EMS_Cert")}
                                            className="mt-0 w-100"
                                            color="secondary"
                                            variant="outlined"
                                        >
                                            {EMTDDL.map(i => <MenuItem value={i.SO_Value} key={i.SO_Value}>{i.SO_Desc} </MenuItem>)}
                                        </TextField>
                                    )}
                                    {!user && (
                                        <TextField
                                            select
                                            SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                            label="EMT"
                                            // defaultValue={user?.EMS_Cert}
                                            {...register("EMS_Cert")}
                                            className="mt-0 w-100"
                                            color="secondary"
                                            variant="outlined"
                                        >
                                            {EMTDDL.map(i => <MenuItem value={i.SO_Value} key={i.SO_Value}>{i.SO_Desc} </MenuItem>)}
                                        </TextField>
                                    )}
                                    {errors.EMS_Cert && (
                                        <p style={{ color: "red" }}>
                                            {errors.EMS_Cert?.message}
                                        </p>
                                    )}
                                </Grid>
                                <Grid item xs={2} sm={1}>
																{user && (
                                    <TextField
                                        select
                                        SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                        label="EMT"
                                        defaultValue={user?.EMS_Cert}
                                        {...register("EMS_Cert")}
                                        className="mt-0 w-100"
                                        color="secondary"
                                        variant="outlined"
                                    >
                                        {EMTDDL.map(i => <MenuItem value={i.SO_Value} key={i.SO_Value}>{i.SO_Desc} </MenuItem>)}
                                    </TextField>
                                )}
                                {!user && (
                                    <TextField
                                        select
                                        SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                        label="EMT"
                                        // defaultValue={user?.EMS_Cert}
                                        {...register("EMS_Cert")}
                                        className="mt-0 w-100"
                                        color="secondary"
                                        variant="outlined"
                                    >
                                        {EMTDDL.map(i => <MenuItem value={i.SO_Value} key={i.SO_Value}>{i.SO_Desc} </MenuItem>)}
                                    </TextField>
                                )}
                                {errors.EMS_Cert && (
                                    <p style={{ color: "red" }}>
                                        {errors.EMS_Cert?.message}
                                    </p>
                                )}
                            </Grid>
                            <Grid item xs={2} sm={1}>
                                <TextField
                                    label={"Ems"}
                                    {...register("Ems")}
                                    className="mt-0 w-100"
                                    color="secondary"
                                    variant="outlined"
                                ></TextField>
                                {errors.Ems && (
                                    <p style={{ color: "red" }}>
                                        {errors.Ems?.message}
                                    </p>
                                )}
                            </Grid>
                        </Grid>
                    </Paper>

                    <Paper className="p-4 my-3">
                        <p className="fw-500 fs-5">Contact Information</p>
                        <Grid
                            container
                            spacing={2}
                            columns={{ xs: 4, sm: 1, md: 4 }}
                        >
                            {!user &&
                                <Grid item xs={2} sm={1}>
                                    <TextField
                                        {...register("Primary_phone")}
                                        className="mt-0 w-100"
                                        color="secondary"
                                        variant="outlined"
                                        label="Primary Phone"
                                    />
                                    {errors.Primary_phone && (
                                        <p style={{ color: "red" }}>
                                            {errors.Primary_phone?.message}
                                        </p>
                                    )}
                                </Grid>
                            }

                            {user &&
                                <Grid item xs={2} sm={1}>
                                    <TextField
                                        {...register("Primary_phone")}
                                        className="mt-0 w-100"
                                        color="secondary"
                                        variant="outlined"
                                        label="Primary Phone"
                                        defaultValue={user.Primary_phone}
                                    />
                                    {errors.Primary_phone && (
                                        <p style={{ color: "red" }}>
                                            {errors.Primary_phone?.message}
                                        </p>
                                    )}
                                </Grid>
                            }

                            <Grid item xs={2} sm={1}>
                                {user && (
                                    <TextField
                                        {...register("Pphone_type")}
                                        className="mt-0 w-100"
                                        color="secondary"
                                        variant="outlined"
                                        select
                                        SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                        label="Type"
                                        defaultValue={user?.Pphone_type}
                                    // helperText="Please select your currency"
                                    >
                                        {ConTypeDDL.map(i => <MenuItem value={i.SO_Value} key={i.SO_Value}>{i.SO_Desc} </MenuItem>)}
                                    </TextField>
                                )}
                                {!user && (
                                    <TextField
                                        {...register("Pphone_type")}
                                        className="mt-0 w-100"
                                        color="secondary"
                                        variant="outlined"
                                        select
                                        SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                        label="Type"
                                        defaultValue={"Cell"}
                                    // helperText="Please select your currency"
                                    >
                                        {ConTypeDDL.map(i => <MenuItem value={i.SO_Value} key={i.SO_Value}>{i.SO_Desc} </MenuItem>)}
                                    </TextField>
                                )}
                                {errors.Pphone_type && (
                                    <p style={{ color: "red" }}>
                                        {errors.Pphone_type?.message}
                                    </p>
                                )}
                            </Grid>
                            <Grid item xs={2} sm={1}>
                                {user && (
                                    <TextField
                                        {...register("Pphone_provider")}
                                        className="mt-0 w-100"
                                        color="secondary"
                                        variant="outlined"
                                        select
                                        SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                        label="Provider"
                                        defaultValue={user?.Pphone_provider}
                                    // helperText="Please select your currency"
                                    >
                                        {CarrierDDL.map(i => <MenuItem value={i.SO_Value} key={i.SO_Value}>{i.SO_Desc} </MenuItem>)}
                                    </TextField>
                                )}
                                {!user && (
                                    <TextField
                                        {...register("Pphone_provider")}
                                        className="mt-0 w-100"
                                        color="secondary"
                                        variant="outlined"
                                        select
                                        SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                        label="Provider"
                                        defaultValue={"AT&T"}
                                    // helperText="Please select your currency"
                                    >
                                        {CarrierDDL.map(i => <MenuItem value={i.SO_Value} key={i.SO_Value}>{i.SO_Value} </MenuItem>)}
                                    </TextField>
                                )}
                                {errors.Pphone_provider && (
                                    <p style={{ color: "red" }}>
                                        {errors.Pphone_provider?.message}
                                    </p>
                                )}
                            </Grid>

                            {!user &&
                                <Grid item xs={2} sm={1}>
                                    <TextField
                                        {...register("Pager")}
                                        className="mt-0 w-100"
                                        color="secondary"
                                        variant="outlined"
                                        label="Call Code"
                                    />
                                    {errors.Pager && (
                                        <p style={{ color: "red" }}>
                                            {errors.Pager?.message}
                                        </p>
                                    )}
                                </Grid>
                            }


                            {user &&
                                <Grid item xs={2} sm={1}>
                                    <TextField
                                        {...register("Pager")}
                                        className="mt-0 w-100"
                                        color="secondary"
                                        variant="outlined"
                                        label="Call Code"
                                        defaultValue={user.Pager}
                                    />
                                    {errors.Pager && (
                                        <p style={{ color: "red" }}>
                                            {errors.Pager?.message}
                                        </p>
                                    )}
                                </Grid>
                            }


                            {!user &&
                                <Grid item xs={2} sm={2} className="add-member">
                                    <TextField
                                        sx={{ color: 'black' }}
                                        {...register("email", {
                                            required: "Email is required",
                                        })}
                                        required={true}
                                        className="mt-0 w-100"
                                        color="secondary"
                                        variant="outlined"
                                        label="Email"
                                    />
                                    {errors.email && (
                                        <p style={{ color: "red" }}>
                                            {errors.email?.message}
                                        </p>
                                    )}
                                </Grid>
                            }

                            {user &&
                                <Grid item xs={2} sm={2} className="add-member">
                                    <TextField
                                        sx={{ color: 'black' }}
                                        {...register("email", {
                                            required: "Email is required",
                                        })}
                                        required={true}
                                        className="mt-0 w-100"
                                        color="secondary"
                                        variant="outlined"
                                        label="Email"
                                        defaultValue={user.email}
                                    />
                                    {errors.email && (
                                        <p style={{ color: "red" }}>
                                            {errors.email?.message}
                                        </p>
                                    )}
                                </Grid>
                            }

                            {!user &&
                                <Grid item xs={2} sm={2} className="add-member">
                                    <TextField
                                        {...register("User_SMS_text")}
                                        className="mt-0 w-100"
                                        color="secondary"
                                        variant="outlined"
                                        placeholder="Login to Firehouse 247 to Accept or Decline."
                                        label="Fill shift message suffix"
                                    />
                                    {errors.User_SMS_text && (
                                        <p style={{ color: "red" }}>
                                            {errors.User_SMS_text?.message}
                                        </p>
                                    )}
                                </Grid>
                            }

                            {user &&
                                <Grid item xs={2} sm={2} className="add-member">
                                    <TextField
                                        {...register("User_SMS_text")}
                                        className="mt-0 w-100"
                                        color="secondary"
                                        variant="outlined"
                                        placeholder="Login to Firehouse 247 to Accept or Decline."
                                        label="Fill shift message suffix"
                                        defaultValue={user.User_SMS_text}
                                    />
                                    {errors.User_SMS_text && (
                                        <p style={{ color: "red" }}>
                                            {errors.User_SMS_text?.message}
                                        </p>
                                    )}
                                </Grid>
                            }

                            <Grid item xs={2} sm={1}>
                                <div>
                                    <LocalizationProvider
                                        dateAdapter={AdapterDateFns}
                                    >
                                        {user && (
                                            <>
                                                <TextField
                                                    className="mt-0 w-100"
                                                    defaultValue={
                                                        user.Hire_date
                                                    }
                                                    color="secondary"
                                                    type="date"
                                                    variant="outlined"
                                                    label="Hire Date"
                                                    {...register("Hire_date", {
                                                        required:
                                                            "Hire Date is required",
                                                    })}
                                                    required={true}
                                                />
                                            </>

                                        )}
                                    </LocalizationProvider>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        {!user && (
                                            <>
                                                <label>Hire Date</label>
                                                <input
                                                    style={{ height: '56px' }}
                                                    type="date"
                                                    className="w-100"
                                                    color="secondary"
                                                    {...register("Hire_date", {
                                                        required: true,
                                                    })}
                                                    required={true}
                                                    label="Hire Date"
                                                />
                                            </>
                                        )}
                                    </LocalizationProvider>
                                </div>
                                {errors.Hire_date && (
                                    <p style={{ color: "red" }}>
                                        {errors.Hire_date?.message}
                                    </p>
                                )}
                            </Grid>

                        </Grid>
                    </Paper>

                    {pages.includes("V3_CERTIFICATE_MODULE") &&
                        <Paper className="p-4 my-3">
                            <p className="fw-500 fs-5">Certifications</p>
                            <Grid
                                container
                                spacing={2}
                            >
                                {!user &&
                                    <Grid item xs={2} sm={1} md={3}>
                                        <label className='my-2'>Certificates</label>
                                        <FormControl className="mt-0 w-100" variant="outlined">
                                            <Select
                                                multiple
                                                color="secondary"
                                                {...register("Certificate_Ids")}
                                                value={watch("Certificate_Ids") || []}
                                                renderValue={(selected) => certificateDropdown?.filter(item => selected.includes(item.value || [])).map(item => item.label).join(", ")}
                                                MenuProps={{ disableScrollLock: true }}
                                            >
                                                {certificateDropdown &&
                                                    Object.values(certificateDropdown).map((item) => (
                                                        <MenuItem key={item.value} value={item.value}>
                                                            <Checkbox checked={watch("Certificate_Ids")?.includes(item.value) || false} />
                                                            {item.label}
                                                        </MenuItem>
                                                    ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                }
                                {user &&
                                    <Grid item xs={2} sm={1} md={6}>
                                        <label>Certificates</label>
                                        <FormControl className="mt-0 w-100" variant="outlined">
                                            <Select
                                                multiple
                                                color="secondary"
                                                {...register("Certificate_Ids")}
                                                defaultValue={user?.employee_certificates?.map((i) => i.Certificate_id)}
                                                value={watch("Certificate_Ids") || []}
                                                renderValue={(selected) => certificateDropdown?.filter(item => selected.includes(item.value || [])).map(item => item.label).join(", ")}
                                                MenuProps={{ disableScrollLock: true }}
                                            >
                                                {certificateDropdown &&
                                                    Object.values(certificateDropdown).map((item) => (
                                                        <MenuItem key={item.value} value={item.value}>
                                                            <Checkbox checked={watch("Certificate_Ids")?.includes(item.value) || false} />
                                                            {item.label}
                                                        </MenuItem>
                                                    ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                }
                            </Grid>
                        </Paper>
                    }

                    <Paper className="p-4 my-3">
                        <p className="fw-500 fs-5">Authorities</p>
                        <Grid
                            container
                            spacing={2}
                        >
                            <Grid item xs={6} sm={6} lg={2}>
                                <div style={{ display: 'flex' }}>
                                    <input
                                        style={{ width: "20px", height: "20px" }}
                                        {...register("Auth_Auth")}
                                        id="flexSwitch"
                                        className="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                    />
                                    <p className="fw-500 fs-16 mx-2"
                                    >Authorities</p>
                                </div>

                            </Grid>
                            <Grid item xs={6} sm={6} lg={2}>
                                <div style={{ display: 'flex' }}>
                                    <input
                                        style={{ width: "20px", height: "20px" }}
                                        {...register("Pass_Auth")}
                                        id="flexSwitch"
                                        className="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                    />
                                    <p className="fw-500 fs-16 mx-2">Passwords</p>
                                </div>
                            </Grid>
                            <Grid item xs={6} sm={6} lg={2}>
                                <div style={{ display: 'flex' }}>
                                    <input
                                        style={{ width: "20px", height: "20px" }}
                                        {...register("Emp_Auth")}
                                        id="flexSwitch"
                                        className="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                    />
                                    <p className="fw-500 fs-16 mx-2">Employees</p>
                                </div>
                            </Grid>
                            <Grid item xs={6} sm={6} lg={2}>
                                <div style={{ display: 'flex' }}>
                                    <input
                                        style={{ width: "20px", height: "20px" }}
                                        {...register("Schedule_Auth")}
                                        id="flexSwitch"
                                        className="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                    />
                                    <p className="fw-500 fs-16 mx-2">Schedule</p>
                                </div>
                            </Grid>
                            <Grid item xs={6} sm={6} lg={2}>
                                <div style={{ display: 'flex' }}>
                                    <input
                                        style={{ width: "20px", height: "20px" }}
                                        {...register("OT_Auth")}
                                        id="flexSwitch"
                                        className="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                    />
                                    <p className="fw-500 fs-16 mx-2">Overtime</p>
                                </div>
                            </Grid>
														{user && pages.includes('V3_INVENTORY_MODULE') &&
															<Grid item xs={6} sm={6} lg={2}>
																	<div style={{ display: 'flex' }}>
																			<input
																					style={{ width: "20px", height: "20px" }}
																					{...register("Inventory_Auth")}
																					id="flexSwitch"
																					className="form-check-input"
																					type="checkbox"
																					role="switch"
																			/>
																			<p className="fw-500 fs-16 mx-2">Add or Edit Inventory</p>
																	</div>
															</Grid>
														}
                        </Grid>
                        <Grid
                            container
                            spacing={2}
                        >
                            <Grid item xs={6} sm={6} lg={2}>
                                <div style={{ display: 'flex' }}>
                                    <input
                                        style={{ width: "20px", height: "20px" }}
                                        {...register("CB_Auth")}
                                        id="flexSwitch"
                                        className="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                    />
                                    <p className="fw-500 fs-16 mx-2">Create Callback</p>
                                </div>
                            </Grid>
                            <Grid item xs={6} sm={6} lg={2}>
                                <div style={{ display: 'flex' }}>
                                    <input
                                        style={{ width: "20px", height: "20px" }}
                                        {...register("CBCls_Auth")}
                                        id="flexSwitch"
                                        className="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                    />
                                    <p className="fw-500 fs-16 mx-2">Close Callback</p>
                                </div>
                            </Grid>
                            <Grid item xs={6} sm={6} lg={2}>
                                <div style={{ display: 'flex' }}>
                                    <input
                                        style={{ width: "20px", height: "20px" }}
                                        {...register("GR_Auth")}
                                        id="flexSwitch"
                                        className="form-check-input"
                                        type="checkbox"
                                        role="switch"

                                        />
                                        <p className="fw-500 fs-16 mx-2">Recall</p>
                                    </div>
                                </Grid>
                                <Grid item xs={6} sm={6} lg={2}>
                                    <div style={{ display: 'flex' }}>
                                        <input
                                            style={{ width: "20px", height: "20px" }}
                                            {...register("SMS_Auth")}
                                            id="flexSwitch"
                                            className="form-check-input"
                                            type="checkbox"
                                            role="switch"
                                        />
                                        <p className="fw-500 fs-16 mx-2">Messaging</p>
                                    </div>
                                </Grid>
                                <Grid item xs={6} sm={6} lg={2}>
                                    <div style={{ display: 'flex' }}>
                                        <input
                                            style={{ width: "20px", height: "20px" }}
                                            {...register("Notes_Auth")}
                                            id="flexSwitch"
                                            className="form-check-input"
                                            type="checkbox"
                                            role="switch"
                                        />
                                        <p className="fw-500 fs-16 mx-2">Edit Notes</p>
                                    </div>
                                </Grid>
																{user && pages.includes('V3_INVENTORY_MODULE') &&
																	<Grid item xs={6} sm={6} lg={2}>
																			<div style={{ display: 'flex' }}>
																					<input
																							style={{ width: "20px", height: "20px" }}
																							{...register("Checklist_Auth")}
																							id="flexSwitch"
																							className="form-check-input"
																							type="checkbox"
																							role="switch"
																					/>
																					<p className="fw-500 fs-16 mx-2">Add or Edit Checklist</p>
																			</div>
																	</Grid>
																}
                            </Grid>
                        </Paper>


                        <Box className="d-flex justify-content-between mt-5 pt-5">
                            <ButtonTheme
                                onClick={back}
                                type="button"
                                variant="filled"
                                className="px-5"
                            >
                                Cancel
                            </ButtonTheme>
                            <ButtonTheme
                                disabled={(!isDirty || !isValid) && (selectedStatus ? !isDirty : isDirty) && (selectReturnDate == "" || undefined ? !isDirty : isDirty)}
                                type="submit"
                                variant="filled"
                                color="DarkRed"
                                className="px-5"
																onClick={() =>{}}
                            >
                                {saving && "Loading..."}	
                                {!saving && "Save"}
                            </ButtonTheme>
                        </Box>
                    {/* </FormControl > */}
                </form >
            </Box >

						<AssignmentHistoryModal
								show={assignmentHistoryModal}
								onHide={() => setAssignmentHistoryModal(false)}
								empId={empId}
								empName={user ? `${user.First_name} ${user.Last_name}` : ""}
								onChanged={refreshEmployeeAssignments}
						/>

						<Modal show={deleteModal} onHide={() => { setDeleteModal(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title>Deletion Warning</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{ color: '#555555' }}>
                        You are about to mark this employee as deleted.
                    </div>
                    <Row>
                        <Col md='auto'>
                            <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={() => { setDeleteModal(false) }}>
                                Confirm
                            </ButtonTheme>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
			</>
        );
    }
}
